<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <!--<el-menu-item index="1" @click="previewStream()" >-->
        <!--<i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>-->
        <!--<span slot="title">概览</span>-->
      <!--</el-menu-item>-->
      <el-menu-item index="2" @click="toNewRouter('latest-policy-manage')" v-if="permissionCodes.indexOf('032001000') !== -1">
        <i class="el-icon-damai-jilu"></i>
        <span slot="title">最新政策</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('hotspot-issues-manage')" v-if="permissionCodes.indexOf('032002000') !== -1">
        <i class="el-icon-damai-redianjiankong" style="font-size: 13px"></i>
        <span slot="title">热点问题</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('live-room-manage')" v-if="permissionCodes.indexOf('032003000') !== -1">
        <i class="el-icon-damai-cloud-direct_broadcasting_room"></i>
        <span slot="title">亲清直播间</span>
      </el-menu-item>
      <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div>
    </el-menu>
  </div>
</template>

<script>
  import navMixin from '../../utils/nav'
  import {bus} from '../../utils/bus'

  const indexOfRouterNameEntities = Object.entries({
    '2': ['latest-policy-manage', 'latest-policy-current'],
    '3': ['hotspot-issues-manage', 'hotspot-issues-current'],
    '4': ['live-room-manage', 'live-room-current']
  })

  export default {
    name: 'enterprise-favour-nav',
    mixins: [navMixin],
    computed:{
      defaultActiveMenuIndex () {
        const {name: routeName} = this.$route
        const entity = indexOfRouterNameEntities
          .find(([, routeNames]) => {
            if (routeNames instanceof Array) {
              return routeNames.indexOf(routeName) >= 0
            } else {
              return routeNames === routeName
            }
          })
        return entity && entity[0]
      }
    },
    data () {
      return {
        isCollapse: false,
        permissionCodes: '',
        indexOfRouterNameEntities
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
    },
    methods: {
      toNewRouter (name) {
        this.$router.push({
          name: name
        })
      },
      previewStream () {
        window.open(`https://yq.damaiiot.com/dataPage.html#/fire_control_login_without/${bus.global.yqCode}/${bus.global.yqName}/${bus.global.accountCode}/${bus.global.personCode || 'null'}/${bus.global.personName || 'null'}`, '_blank')
      },
    }
  }
</script>

<style lang="less" scoped>
  @import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/EnterpriseFavour/EnterpriseFavourNav.vue